import request from '@/api/request'
/**
 * 搜索证书
 */
export const queryCertificate = (params) => {
  return request({
    url: 'radioweb/app/web/queryCertificate',
    params,
    method: 'get'
  })
}
/**
 * 证书验证码
 */
export const randomCode = (params) => {
  return request({
    url: 'radioweb/app/web/randomCode',
    params,
    method: 'get'
  })
}

/**
 * 证书详情
 */
export const queryCertificateByNum = (data) => {
  return request({
    url: 'product/app/userTestPlan/queryCertificateByNum',
    method: 'post',
    type: 'json',
    data
  })
}
